import { render, staticRenderFns } from "./Feed_Upcoming_Component.vue?vue&type=template&id=f14049fa&scoped=true"
import script from "./Feed_Upcoming_Component.vue?vue&type=script&lang=js"
export * from "./Feed_Upcoming_Component.vue?vue&type=script&lang=js"
import style0 from "./Feed_Upcoming_Component.vue?vue&type=style&index=0&id=f14049fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14049fa",
  null
  
)

export default component.exports